import type { SkeletonProps } from '@mui/material/Skeleton';
import Skeleton from '@mui/material/Skeleton';
import React from 'react';

import styles from './LoadingState.scss';

interface Props {
  height: number;
}

const skeletonProps: SkeletonProps = {
  className: styles.skeleton,
  variant: 'circular',
  height: 'var(--spaceXL)',
  width: 'var(--spaceXL)',
  animation: 'pulse'
};

const LoadingState: React.FC<Props> = ({ height }) => (
  <div className={styles.container} style={{ height: `${height}px` }}>
    <Skeleton {...skeletonProps} />
    <Skeleton {...skeletonProps} />
    <Skeleton {...skeletonProps} />
    <Skeleton {...skeletonProps} />
    <Skeleton {...skeletonProps} />
  </div>
);

export default LoadingState;
